export enum WorkOrderState {
  STARTED = 'STARTED',
  ISSUED = 'ISSUED',
}
